import idataCodingStyles from '../../common/global-styles/idatacoding.module.less'
import projectStyles from '../project.module.less'
import React, { useEffect, useRef, useState } from 'react'
import {
  Table,
  message,
  Col,
  Row,
  Tabs,
  Button,
  Input,
  Popconfirm,
  Modal,
  ConfigProvider,
  Pagination,
  Tooltip,
} from 'antd'
import TooltipModal from '../../../component/modal/stop-task-modal/TooltipModal'
import {
  SyncOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  StopOutlined,
  ClockCircleOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import './project-my-submit.less'
import zhCN from 'antd/lib/locale/zh_CN'
import { BACKEND_API_URL } from '../../../constants/constants'
import { sendHttpPostRequest } from '../../../api/http-request'
import Cookies from 'js-cookie'
import { useLocation } from 'react-router-dom'

const { Search } = Input

export interface Props {}

const ProjectMySubmit: React.FC<Props> = (props) => {
  const page = useRef(1)
  const pageSize = useRef(10)
  const location = useLocation()
  const order = useRef<any>('')
  const orderBy = useRef<any>('')
  const statusFilters = useRef<any>([])

  const projectId = location.search.includes('my_commit_record')
    ? location.search.split('project_id=')[1].split('/')[0]
    : location.search.split('project_id=')[1]

  const query = useRef('')

  const [total, setTotal] = useState(0)
  const [tooltipopen, setTooltipopen] = useState(false)
  const [actionTask, setActionTask] = useState({} as any)
  const [commitRecordData, setCommitRecordData] = useState([] as any)

  const renderTime = (text: any, record: any, index: number) => {
    if (text < 60) {
      return text + '秒'
    } else if (3600 > text && text > 60) {
      if (text % 60 == 0) {
        return text / 60 + '分'
      }
      return parseInt((text / 60).toString()) + '分' + (text % 60) + '秒'
    } else if (text >= 3600) {
      if (text % 3600 == 0) {
        return text / 3600 + '时'
      } else if (text / 3600 !== 0 && (text % 3600) % 60 == 0) {
        return (
          parseInt((text / 3600).toString()) + '时' + (text % 3600) / 60 + '分'
        )
      }
      return (
        text / 3600 +
        '时' +
        (text % 3600) / 60 +
        '分' +
        ((text % 3600) % 60) +
        '秒'
      )
    }
  }
  const renderStatus = (text: any, record: any, index: any) => {
    const cfgMap: Record<string, {bg: string; color: string; border: string; icon: React.ReactNode; label: string}> = {
      '运行中': { bg: '#eef2ff', color: '#4f46e5', border: '#c7d2fe', icon: <SyncOutlined spin style={{marginRight: 5}} />, label: '运行中' },
      '成功':   { bg: '#f0fdf4', color: '#16a34a', border: '#bbf7d0', icon: <CheckCircleOutlined style={{marginRight: 5}} />, label: '成功' },
      '失败':   { bg: '#fef2f2', color: '#dc2626', border: '#fecaca', icon: <CloseCircleOutlined style={{marginRight: 5}} />, label: '失败' },
      '已停止': { bg: '#f9fafb', color: '#6b7280', border: '#e5e7eb', icon: <StopOutlined style={{marginRight: 5}} />, label: '已停止' },
      'queueing': { bg: '#faf5ff', color: '#7c3aed', border: '#e9d5ff', icon: <ClockCircleOutlined style={{marginRight: 5}} />, label: '排队中' },
    }
    const cfg = cfgMap[text]
    if (!cfg) return ''
    return (
      <span style={{
        display: 'inline-flex', alignItems: 'center',
        padding: '2px 10px', borderRadius: 999, fontSize: 12, fontWeight: 500,
        background: cfg.bg, color: cfg.color, border: `1px solid ${cfg.border}`,
        whiteSpace: 'nowrap',
      }}>
        {cfg.icon}{cfg.label}
      </span>
    )
  }

  const taskPreview = (record) => {
    window.open(
      `/task_learn?project/${record.project_id}/chapter/${record.chapter_id}/task/${record.exercise_id}/`
    )
  }

  const renderAction = (text: any, record: any, index: number) => (
    <Row align="middle" justify="center">
      <Col flex={'30px'}>
        <Tooltip placement="top" title={'查看'}>
          <div
            className="preview-icon"
            onClick={taskPreview.bind(this, record)}
          >
            <i className="iconfont icon-chakan"></i>
          </div>
        </Tooltip>
      </Col>
      { record.status === '运行中'  && <Col flex={'30px'}>

          <Tooltip placement="top" title={'停止'}>
            <div
              className="stoped-icon"
              onClick={() => {
                setActionTask(record)
                setTooltipopen(true)
              }}
            >
              <i className="iconfont icon-zhongzhi"></i>
            </div>
          </Tooltip>
    
      </Col> }
    </Row>
  )

  const onTableChange: any = (
    pagination: any,
    filters: any,
    sorter: any,
    extra: { currentDataSource: []; action: any }
  ) => {
    if (sorter.order) {
      //如果选择了排序列
      order.current = sorter.order
      orderBy.current = sorter.field
    } else {
      order.current = ''
      orderBy.current = ''
    }
    if (filters.status) {
      //如果选择了过滤列
      statusFilters.current = filters.status
    } else {
      statusFilters.current = []
    }

    page.current = 1
    getCommitRecord()
  }

  const CommitRecordCols: any = [
    {
      title: '序号',
      dataIndex: 'commit_index',
      key: 'commit_index',
      width: '50px',
      align: 'center',
      render: (text, record) =>
        (page.current - 1) * pageSize.current +
        commitRecordData.indexOf(record) +
        1,
    },
    {
      title: '任务编号',
      dataIndex: 'task_number',
      key: 'task_number',
      width: '80px',
      align: 'center',
    },
    {
      title: '任务名称',
      dataIndex: 'title',
      key: 'title',
      width: '150px',
      align: 'left',
      ellipsis: true,
      render: (t, r, i) => {
        return (
          <Tooltip placement="top" title={t}>
            <span
              className={idataCodingStyles.link}
              onClick={taskPreview.bind(this, r)}
            >
              {t}
            </span>
          </Tooltip>
        )
      },
    },
    {
      title: '开始时间',
      dataIndex: 'req_time',
      key: 'req_time',
      width: '150px',
      align: 'center',
      sorter: true,
    },
    {
      title: '结束时间',
      dataIndex: 'res_time',
      key: 'res_time',
      width: '150px',
      align: 'center',
      sorter: true,
    },
    {
      title: '用时',
      dataIndex: 'time_range',
      key: 'time_range',
      width: '150px',
      align: 'center',
      sorter: true,
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      width: '100px',
      align: 'left',
      filters: [
        {
          text: '运行中',
          value: '1',
        },
        {
          text: '成功',
          value: '2',
        },
        {
          text: '失败',
          value: '3',
        },
        {
          text: '已停止',
          value: '4',
        },
      ],
      render: renderStatus,
    },
    {
      title: '备注',
      dataIndex: 'err_remark',
      key: 'err_remark',
      width: '100px',
      ellipsis: true,
      align: 'center',
      render: (t, r, i) => (
        <Tooltip title={t} placement="topLeft">
          <span>{t}</span>
        </Tooltip>
      ),
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      width: '100px',
      align: 'center',
      render: renderAction,
    },
  ]

  const getCommitRecord = () => {
    let data = {
      project_id: projectId,
      page: page.current,
      page_size: pageSize.current,
      query: query.current,
      order: order.current,
      order_by: orderBy.current,
      status: JSON.stringify(statusFilters.current),
    }
    sendHttpPostRequest('exercise/api/my_exercise_run_list', data, (res) => {
      if (res.code == 0) {
        setCommitRecordData(res.data.list)
        setTotal(res.data.page_info.total_count)
      } else {
        message.error(res.msg)
      }
    })
  }

  useEffect(() => {
    getCommitRecord()
    return () => {}
  }, [])

  const onPageChange = (newPage: number, newPageSize: number) => {
    page.current = newPage ? newPage : 1
    if (newPageSize) {
      pageSize.current = newPageSize
    }
    getCommitRecord()
  }

  const searchByTaskName = () => {
    page.current = 1
    getCommitRecord()
  }

  const onStopTaskOk = () => {
    let data = {
      source: 1, //1 我的   2 学生
      exercise_submit_id: actionTask?.id,
      exercise_id: actionTask?.exercise_id,
      // interrupt_list:actionTask, // 批量
    }
    sendHttpPostRequest(
      'exercise/api/running_exercise_interrupt',
      data,
      (res) => {
        console.log(res)
        if (res.code == 0) {
          getCommitRecord()
          message.success('停止成功~')
        } else {
          message.error(res.msg)
        }
      }
    )
    setTooltipopen(false)
  }

  return (
    <div style={{minWidth: 800}}>
      <div style={{marginBottom: 16}}>
        <Input
          onPressEnter={searchByTaskName}
          onChange={(e) => { query.current = e.target.value }}
          size="middle"
          placeholder="请输入任务名称/编号..."
          prefix={<SearchOutlined style={{color: '#9ca3af'}} />}
          style={{borderRadius: 8, width: 320, height: 36}}
        />
      </div>

      <div className={idataCodingStyles.tableWrapper}>
        <ConfigProvider locale={zhCN}>
          <Table
            className={projectStyles.studentTable}
            dataSource={commitRecordData}
            columns={CommitRecordCols}
            rowKey={(record) => record.id}
            pagination={false}
            onChange={onTableChange}
            scroll={{ x: 800 }}
            size="small"
          />
        </ConfigProvider>
      </div>
      <div
        className={idataCodingStyles.dfPagination}
        style={{ textAlign: 'center', marginTop: 20 }}
      >
        <ConfigProvider locale={zhCN}>
          <Pagination
            pageSize={pageSize.current}
            total={total}
            current={page.current}
            onChange={onPageChange}
            hideOnSinglePage
          />
        </ConfigProvider>
      </div>
      <TooltipModal
        tooltipopen={tooltipopen}
        setTooltipopen={setTooltipopen}
        mode={'user'}
        onOk={onStopTaskOk}
        content={<p>此任务正在运行中，确定要停止任务吗？</p>}
      />
    </div>
  )
}

export default ProjectMySubmit
